
import { useQuery } from "@tanstack/react-query";
import { getReportsTrending } from "../../API/ProtectedAuth";
import { handleApiError } from "../../Utils/errorHandler";

export default function useTrending(options = {}) {
  const { onSuccess, onError, enabled = true, period = "7d" } = options;

  const {
    data,
    error,
    isLoading,
    refetch: reload,
  } = useQuery({
    queryKey: ["reportsTrending", period],
    queryFn: async () => {
      try {
        const response = await getReportsTrending({ period });
        return response;
      } catch (err) {
        handleApiError(err);
        throw err;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 60, 
    cacheTime: 1000 * 60 * 60 * 12,
    refetchOnWindowFocus: false,
    onSuccess,
    onError,
  });

  const insights = data?.data?.insights || [];
  const generatedAt = data?.meta?.generated_at
    ? new Date(data.meta.generated_at).toLocaleDateString("en-EG")
    : null;

  return {
    insights,
    generatedAt,
    error,
    isLoading,
    reload,
    period,
  };
}


























































